import { LoginTemplate } from '@/templates'

const Login = (): JSX.Element => {
  return <LoginTemplate />
}

export default Login
